<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">Les dix derniers paiements du jour</h6>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Réf.
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Coût
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Usager
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Periode
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              >
                Etat
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(red, index) in factures" :key="index">
              <th class="shadow-none lh-1 fw-bold ps-0">
                
                  {{ red.refPaiement }}
              </th>
              <td class="shadow-none lh-1 fw-medium">
                {{ separateur(red.montantPaye) }}
                <span class="text-body-tertiary"> FCFA</span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div class="d-flex align-items-center">
                  
                  {{ red.contrat?.matricule?.nom }} {{ red.contrat?.matricule?.prenom }}
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ red.periode }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ format_date(red.datePaiement) }}
              </td>
              <td class="shadow-none lh-1 fw-medium pe-0">
                <span v-if="red.statut === 'SUCCESS'" class="badge text-outline-success">{{ "SUCCESS" }}</span>
                <span v-else-if="red.statut === 'RAS'" class="badge text-outline-info">{{ "RAS" }}</span>
                <span v-else class="badge text-outline-warning">{{ red.statut }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent,ref,onMounted,reactive } from "vue";
import axios from 'axios';
import {separateur, format_date} from '../../../../utils/utils'

export default defineComponent({
  name: "ProductsOrders",
  setup: () => {
    const factures = ref([]);
    const fetchFactures =async () => {
      try {
        const response = await axios.get(`etats/dernieres/extensions`);
        factures.value = response.data.data;
        return factures.value;
      } catch (error) {
        //
      }
    }
    const moisNoms = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];
    onMounted(() => {
      factures.value;
      fetchFactures();
    });
    return {
      separateur,
      factures,
      format_date,
      fetchFactures,
      moisNoms
    };
  },
});
</script>